import { CbcState } from '@/store/cbc/state';
import { Mutations } from 'vuex-smart-module';
import { PhoneType, CbcResponse, CreditScore, VerificationCodeResponse } from '@/types/cbc';

export class CbcMutations extends Mutations<CbcState> {
	setPhoneType(type: PhoneType) {
		this.state.phoneType = type;
	}

	unsetPhoneType() {
		this.state.phoneType = null;
	}

	setCreditScore(score: CreditScore) {
		this.state.creditScore = score;
	}

	unsetCreditScore() {
		this.state.creditScore = null;
	}

	setCbcError() {
		this.state.isCbcError = true;
	}

	unsetCbcError() {
		this.state.isCbcError = false;
	}

	setCbcSuccess() {
		this.state.isCbcSuccess = true;
	}

	unsetCbcSuccess() {
		this.state.isCbcSuccess = false;
	}

	setLoading() {
		this.state.isLoading = true;
	}

	unsetLoading() {
		this.state.isLoading = false;
	}

	setCbcVerificationCode(response: VerificationCodeResponse) {
		this.state.verificationCodeResponse = response;
	}

	setIsCreditScoreUpdated() {
		this.state.isCreditScoreUpdated = true;
	}

	unsetIsCreditScoreUpdated() {
		this.state.isCreditScoreUpdated = false;
	}

	setCbcSuccessResponse(response: CbcResponse) {
		this.state.cbcSuccessResponse = response;
	}

	unsetCbcSuccessResponse() {
		this.state.cbcSuccessResponse = null;
	}

	resetCbcStates() {
		this.state.isCbcError = false;
		this.state.isCbcSuccess = false;
	}

	toggleCreditAppLauncher() {
		this.state.showCreditAppLauncher = !this.state.showCreditAppLauncher;
	}

	incrementAddress() {
		this.state.addressCount += 1;
		this.state.creditAppFormSubmitted = false;
	}

	decrementAddress() {
		this.state.addressCount -= 1;
		this.state.creditAppFormSubmitted = false;
	}

	incrementEmployment() {
		this.state.employmentCount += 1;
		this.state.creditAppFormSubmitted = false;
	}

	decrementEmployment() {
		this.state.employmentCount -= 1;
		this.state.creditAppFormSubmitted = false;
	}

	setCreditAppSubmitted() {
		this.state.creditAppFormSubmitted = true;
	}

	unsetCreditAppSubmitted() {
		this.state.creditAppFormSubmitted = false;
	}
}
